module.exports = __webpack_public_path__ + "static/media/delivery_fees_rev6.d53a526f.jpg";